import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'qr-status-filter',
  templateUrl: './status-filter.component.html',
  styleUrls: ['./status-filter.component.css']
})
export class StatusFilterComponent {
  @Input() activeStatus: string = 'CHO_XU_LY';
  @Output() statusChange = new EventEmitter<string>();

  tabs = [
    { value: 'CHO_XU_LY', label: 'Chờ xử lý' },
    { value: 'DA_TIEP_NHAN', label: 'Đã tiếp nhận' },
    { value: 'TU_CHOI', label: 'Từ chối' }
  ];

  selectTab(value: string) {
    this.activeStatus = value;
    this.statusChange.emit(value);
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/status-filter/status-filter.component.ts